module.exports = __webpack_public_path__ + "static/media/G2G.5db860ce.png";